<template>
    <div>
        <ckeditor v-if="isLayoutReady" ref="editor" v-model="editorData" :config="config" :editor="editor"/>
    </div>
</template>

<script>
    import CKEditor from '@ckeditor/ckeditor5-vue2';
    import {
        Bold,
        ClassicEditor,
        Essentials,
        GeneralHtmlSupport,
        Heading,
        Italic,
        Link,
        List,
        Paragraph,
        PasteFromOffice,
        SourceEditing,
        Underline,
        Undo
    } from 'ckeditor5';

    import translations from 'ckeditor5/translations/de.js';

    import 'ckeditor5/ckeditor5.css';
    import '@scss/components/ckeditor.scss';

    export default {
        components: {
            ckeditor: CKEditor.component,
        },
        props: {
            textareaId: {
                type: String,
                default: null,
            },
        },
        data() {
            return {
                config: null,
                editor: ClassicEditor,
                editorData: '',
                isLayoutReady: false,
            };
        },
        watch: {
            editorData(value) {
                if (this.textareaId === null || this.textareaId === undefined) {
                    return;
                }
                const element = document.querySelector('#' + this.textareaId);
                element.textContent = value;
                element.dispatchEvent(new Event('change'));
            },
        },
        mounted() {
            this.config = {
                toolbar: {
                    items: [
                        'undo',
                        'redo',
                        '|',
                        'heading',
                        '|',
                        'bold',
                        'italic',
                        'underline',
                        '|',
                        'bulletedList',
                        '|',
                        'link',
                        'sourceEditing',
                    ],
                    shouldNotGroupWhenFull: true,
                },
                plugins: [
                    Bold,
                    Essentials,
                    GeneralHtmlSupport,
                    Heading,
                    Italic,
                    Link,
                    List,
                    Paragraph,
                    PasteFromOffice,
                    SourceEditing,
                    Underline,
                    Undo,
                ],
                heading: {
                    options: [
                        {
                            model: 'paragraph',
                            title: 'Paragraph',
                            class: 'ck-heading_paragraph',
                        },
                        {
                            model: 'heading1',
                            view: 'h1',
                            title: 'Überschrift 1',
                            class: 'ck-heading_heading1',
                        },
                        {
                            model: 'heading2',
                            view: 'h2',
                            title: 'Überschrift 2',
                            class: 'ck-heading_heading2',
                        },
                    ],
                },
                language: 'de',
                htmlSupport: {
                    allow: [
                        {
                            name: /^.*$/,
                            styles: true,
                            attributes: true,
                            classes: true,
                        },
                    ],
                },
                link: {
                    addTargetToExternalLinks: true,
                    defaultProtocol: 'https://',
                },
                placeholder: '',
                translations: [translations],
            };
            if (this.textareaId !== null && this.textareaId !== undefined) {
                this.editorData = document.querySelector('#' + this.textareaId).textContent;
            }
            this.isLayoutReady = true;
        },
    };
</script>
